module.exports = __webpack_public_path__ + "static/closed-for-the-winter-season-010b47177f5f1145cc6f7c1d8604e1ea.jpg";